import { render, staticRenderFns } from "./PageMessageArea.vue?vue&type=template&id=c8165a12&scoped=true&"
import script from "./PageMessageArea.vue?vue&type=script&lang=js&"
export * from "./PageMessageArea.vue?vue&type=script&lang=js&"
import style0 from "./PageMessageArea.vue?vue&type=style&index=0&id=c8165a12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8165a12",
  null
  
)

export default component.exports